<template>
       <div class="nav-content-main">
         <navComponent></navComponent>
          <el-row class="tac">
              <el-col>
                  <el-menu
                  class="el-menu-vertical-demo"
                  @select="handleSelect"
                  background-color="#545c64"
                  text-color="#fff"
                  active-text-color="#09080D">
                  <el-menu-item index="first">
                      <span slot="title">Home</span>
                  </el-menu-item>
                  <el-menu-item index="second">
                      <span slot="title">Travel</span>
                  </el-menu-item>
                  <el-submenu index="third">
                      <template slot="title">
                      <span>Experience</span>
                      </template>
                      <el-menu-item index="1">Accommodations</el-menu-item>
                      <el-menu-item index="2">Traffic</el-menu-item>
                      <el-menu-item index="3">Activities</el-menu-item>
                      <el-menu-item index="4">Services</el-menu-item>
                  </el-submenu>
                  <el-menu-item index="fourth">
                      <span slot="title">About Us</span>
                  </el-menu-item>
                  <el-menu-item index="fifth">
                      <span slot="title">Book Now</span>
                  </el-menu-item>
                  </el-menu>
              </el-col>
          </el-row>
        <!-- <fromMoveNow v-show="isContractUs && navShow"></fromMoveNow> -->
        <div class="contractUs">
            <img loading="lazy" :src="navPhone" alt="" class="contractUs-left">
            <div class="contractUs-right">
                contract us
            </div>
        </div>
    </div>
</template>
<script>
// import fromMoveNow from '/components/pc/bookNow/fromMoveNow.vue'
import navPhone from '/static/img/nav/phone.png'
import navComponent from '/components/pc/headerComponent/navComponent.vue'
export default{
    components:{
        navComponent
    },
    data(){
        return{
            navPhone:navPhone,
        }
    },
    methods:{
        handleSelect(key) {
            if(key == 'first'){
                this.$router.push('/')
            }else if(key == 'second'){
                this.$router.push('/travel')
            }else if(key == 'fourth'){
                this.$router.push('/aboutUs')
            }else if(key == 'fifth'){
                this.$router.push('/moveNow')
            }
            if(key == 1){
            this.$router.push('/experience/accommodations?navId=1')
            }else if(key == 2){
                this.$router.push('/experience/traffic?navId=2')
            }else if(key == 3){
                this.$router.push('/experience/activities?navId=3')
            }else if(key == 4){
                this.$router.push('/experience/services?navId=4')
            }
          this.navShow = false
          this.isContractUs = false
        },
    }
}
</script>
<style scoped lang="scss">
::v-deep  .el-menu-item, ::v-deep .el-submenu__title{
    cursor: auto !important;
    background: #09080D !important;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Inter;
    font-size: 20px;
    font-weight: 500;
    height: 64px;
}
::v-deep .el-menu{
    border: none;
    background: #09080D !important;
}
::v-deep .is-active{
    background: #09080D !important;
    color: rgba(255, 255, 255, 0.5) !important;
}
::v-deep .el-submenu__icon-arrow{
    font-size: 20px;
}
.nav-content-main{
    margin-top: 64px;
    background: #09080D;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: calc(100vh - 64px);
    justify-content: space-between; /* Ensure content is aligned from the top */
    .nav-header{
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        height: 64px;
        align-items: center;
        background: #09080D;
        position: fixed;
        top: 0;
        z-index: 100;
        width: calc(100% - 40px);
        img{
            display: block;
        }
        img:nth-child(1){
            width: 46px;
            height: 30px;
        }
        img:nth-child(2){
            width: 24px;
            height: 24px;
        }
    }
      .contractUs{
            margin: 70px auto 70px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 1px solid rgba(255, 255, 255, 0.52);
            width: 155px;
            height: 44px;
            border-radius: 2px;
            .contractUs-left{
            display: block;
            width: 14px;
            height: 14px;
            margin-right: 10px;
            }
            .contractUs-right{
            color: #FFF;
            font-family: Inter;
            font-weight: 400;
            cursor: pointer;
            font-size: 16px;
            }
        }
}
</style>